export const STATUSES = ["confirmed", "completed", "invoice_sent", "partially_paid", "paid", "cancelled"];

// Pastel rounded-pill badges — matches the Clients page's ClientBadges visual language.
export const STATUS_STYLES = {
  confirmed: "rounded-full bg-[#E8F1FD] text-[#1D4E89]",
  completed: "rounded-full bg-[#F1F2F4] text-[#51565F]",
  invoice_sent: "rounded-full bg-[#E8F1FD] text-[#1D4E89]",
  partially_paid: "rounded-full bg-[#FBF2E1] text-[#8A6529]",
  paid: "rounded-full bg-[#E5F7ED] text-[#087443]",
  cancelled: "rounded-full bg-[#FBEAE9] text-[#B3261E]",
};

// Shared premium theme tokens — keep every admin page (Orders, Schedule, Delivery, Settings, etc.)
// visually consistent with the Clients page redesign.
export const thCls = "text-[11px] font-semibold uppercase tracking-[0.1em] text-[#475467] bg-[#F7F9FC]";
export const inputCls = "mt-1 rounded-xl border-[#E4E9F0] focus-visible:ring-[#0C2347]/15";
export const cardCls = "rounded-[14px] border border-[#E4E9F0] bg-white";
export const cardShadow = { boxShadow: "0 4px 20px rgba(15,23,42,0.035)" };
export const pageHeadingCls = "font-serif-display text-4xl sm:text-[42px] mt-2 text-[#101828]";
export const primaryBtnCls = "rounded-xl bg-[#0C2347] hover:bg-[#123262] text-white shadow-[0_3px_8px_rgba(12,35,71,0.13)] transition-all hover:-translate-y-px";
export const outlineBtnCls = "rounded-xl border-[#E4E9F0] text-[#475467] hover:border-[#0C2347]/30";
export const pillTabCls = "rounded-xl data-[state=active]:bg-[#0C2347] data-[state=active]:text-white font-mono text-[11px] uppercase tracking-[0.1em]";
